import { render } from "./StandardDocuments.vue?vue&type=template&id=c7b0f03e&scoped=true"
import script from "./StandardDocuments.vue?vue&type=script&lang=js"
export * from "./StandardDocuments.vue?vue&type=script&lang=js"

import "./StandardDocuments.vue?vue&type=style&index=0&id=c7b0f03e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7b0f03e"]])

export default __exports__